import { flattenPermissions } from '@gef-ui/cdu-user/utils';
import path from "ramda/es/path";
import find from "ramda/es/find";
import includes from "ramda/es/includes";
import isNil from "ramda/es/isNil";
import map from "ramda/es/map";
import omit from "ramda/es/omit";
import prop from "ramda/es/prop";
import toLower from "ramda/es/toLower";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import { EXCLUDE_URL_REDIRECT } from '../constants';
const UNDEFINED_USER = 'undefinedUser';
const REPRESENTATIVE_FOR = 'representativeFor';
const ORIGINAL_USER = 'originalUser';
const COMING_FROM_URL = 'comingFromUrl';
export const setDelegationCookies = (representativeFor)=>{
    window.sessionStorage.setItem(REPRESENTATIVE_FOR, representativeFor);
};
export const setOriginalUserCookies = (userLogin)=>{
    window.sessionStorage.setItem(ORIGINAL_USER, userLogin);
};
export const setUndefinedUserCookies = (userLogin)=>{
    window.sessionStorage.setItem(UNDEFINED_USER, userLogin);
};
export const setDelegationsFromQuery = ()=>{
    const query = new URLSearchParams(location.search);
    if (query.get('representativeFor')) {
        window.sessionStorage.setItem(UNDEFINED_USER, query.get('representativeFor'));
    }
};
export const getComingFromUrl = ()=>{
    return window.localStorage.getItem(COMING_FROM_URL);
};
export const setComingFromUrl = ()=>{
    if (isNilOrEmpty(getComingFromUrl())) {
        window.localStorage.setItem(COMING_FROM_URL, window.location.pathname + window.location.search);
    }
};
export const revokeDelegationCookies = ()=>{
    window.sessionStorage.removeItem(REPRESENTATIVE_FOR);
};
export const revokeOriginalUserCookies = ()=>{
    window.sessionStorage.removeItem(ORIGINAL_USER);
};
export const revokeUndefinedUserFromCookie = ()=>{
    window.sessionStorage.removeItem(UNDEFINED_USER);
};
export const revokeComingFromUrl = ()=>{
    window.localStorage.removeItem(COMING_FROM_URL);
};
export const getDelegationCookies = ()=>{
    const representativeFor = window.sessionStorage.getItem(REPRESENTATIVE_FOR);
    if (representativeFor) {
        return {
            representativeFor
        };
    } else {
        return undefined;
    }
};
export const getOriginalUserCookies = ()=>{
    const originalUser = window.sessionStorage.getItem(ORIGINAL_USER);
    if (originalUser) {
        return {
            originalUser
        };
    } else {
        return undefined;
    }
};
export const getUndefinedUserFromCookie = ()=>{
    const undefinedUser = window.sessionStorage.getItem(UNDEFINED_USER);
    if (undefinedUser) {
        return {
            representativeFor: undefinedUser
        };
    } else {
        return undefined;
    }
};
export const resolveDelegationUser = (userFromToken)=>{
    const undefinedUserFromCookie = getUndefinedUserFromCookie();
    if (!isNilOrEmpty(undefinedUserFromCookie)) {
        revokeUndefinedUserFromCookie();
        revokeOriginalUserCookies();
        revokeDelegationCookies();
        if (!isNilOrEmpty(userFromToken) && toLower(undefinedUserFromCookie?.representativeFor) === toLower(userFromToken)) {
            setOriginalUserCookies(undefinedUserFromCookie.representativeFor);
        } else {
            setDelegationCookies(undefinedUserFromCookie.representativeFor);
        }
    }
};
export const appendToEachDelegation = map((delegation)=>({
        userLogon: delegation.userNameAd,
        firstName: delegation.firstname,
        ...delegation
    }));
export const pickDelegationFromUserInfoResponse = (response)=>{
    const body = prop('body', response);
    return appendToEachDelegation(body.delegations);
};
export const pickOtherFromUserInfoResponse = (response)=>{
    const body = prop('body', response);
    return {
        ...omit([
            'delegations',
            'permissions'
        ], body),
        userFullName: `${body.surname} ${body.firstname}`,
        userLogon: body.userNameAd,
        firstName: body.firstname,
        permissions: flattenPermissions(body.permissions)
    };
};
export const getErrorContentPath = path([
    'failure',
    'parsedContent'
]);
export const includeExcludedUrl = (comeFromUrl = '')=>{
    const found = find((url)=>includes(url, comeFromUrl))(EXCLUDE_URL_REDIRECT);
    return !isNil(found);
};
export const errorContentPath = path([
    'failure',
    'parsedContent'
]);
export const isCannotDelegate = ({ type = '' })=>type.includes('CannotDelegateException');
export const removeUserAndCompanyFromUrl = (url)=>{
    const newUrl = new URL(`${window.location.origin}${url}`);
    const params = new URLSearchParams(newUrl.search);
    params.delete(REPRESENTATIVE_FOR);
    params.delete(ORIGINAL_USER);
    params.delete(UNDEFINED_USER);
    newUrl.search = params.toString();
    return newUrl.href;
};
